import React, { useContext } from 'react';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { SelectedTire, WizardContext } from 'compositions/Wizard/WizardContext';
import { UFOPart, VehicleType } from 'types/UFOTypes';
import { CommonPricesParamsType } from 'utils/getPricesCallCommonParams';
import { BREAKPOINT } from 'utils/responsivenessUtils';
import WizardTireInformationDesktop from './WizardTireInformationDesktop';
import WizardTireInformationMobile from './WizardTireInformationMobile';

interface WizardTireInformationProps {
  tire: UFOPart;
  vehicle?: VehicleType;
  fittingTires: string[];
  selectedTires: SelectedTire[];
  setSelectedTires: React.Dispatch<React.SetStateAction<SelectedTire[]>>;
  commonPricesParams: CommonPricesParamsType;
  isLumped?: boolean;
}
export default function WizardTireInformation(props: WizardTireInformationProps) {
  const { tire, vehicle, fittingTires, selectedTires, setSelectedTires, commonPricesParams, isLumped } = props;
  const theme = useTheme();
  const mobileView = useMediaQuery(theme.breakpoints.down(BREAKPOINT));
  const { selectedTires: contextSelectedTires, setSelectedTires: contextSetSelectedTires } = useContext(WizardContext);

  return (
    <>
      {!mobileView && (
        <WizardTireInformationDesktop
          fittingTires={fittingTires}
          isLumped={isLumped}
          tire={tire}
          vehicle={vehicle}
          commonPricesParams={commonPricesParams}
          selectedTires={contextSelectedTires || selectedTires}
          setSelectedTires={contextSetSelectedTires || setSelectedTires}
        />
      )}
      {mobileView && (
        <WizardTireInformationMobile
          fittingTires={fittingTires}
          isLumped={!!tire?.child?.length}
          tire={tire}
          vehicle={vehicle}
          selectedTires={contextSelectedTires || selectedTires}
          setSelectedTires={contextSetSelectedTires || setSelectedTires}
          commonPricesParams={commonPricesParams}
        />
      )}
    </>
  );
}
